import { RootState } from '@redux/store';

export const getListBrandTyres = (state: RootState) => state.brand.brandListTyres;

export const getListBrandDisks = (state: RootState) => state.brand.brandListDisks;

export const getListBrandAkb = (state: RootState) => state.brand.brandListAkb;

export const getListBrandOils = (state: RootState) => state.brand.brandListOils;

export const getListBrandTruckTyres = (state: RootState) => state.brand.brandListTruckTyres;
